import { useState } from 'react';
import './ScrollUp.scss';
import { useLocation } from 'react-router-dom';

interface IProps {
  excludeFromPaths?: string[];
}

const ScrollUp = ({ excludeFromPaths = [] }: IProps) => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  const handleScrollUpVisible = () => {
    const scrolled = window.scrollY;

    if (!visible && scrolled > 300) setVisible(true);
    else if (visible && scrolled <= 300) setVisible(false);
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  window.addEventListener('scroll', handleScrollUpVisible);

  return !excludeFromPaths.some((excludedPath) =>
    pathname.startsWith(excludedPath)
  ) ? (
    <button
      className='ScrollUp'
      onClick={scrollTop}
      style={{ display: visible ? 'flex' : 'none' }}
    >
      <div className='ScrollUp__arrow'></div>
    </button>
  ) : null;
};

export default ScrollUp;
